<template>
    <ContentOrLoading>
        <b-container v-if="datos_abonos.length > 0">
            <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                <b-row>
                    <b-col cols="12">
                        <DatosCompradorComponent
                            :datos_comprador.sync="comprador"
                        />
                    </b-col>
                    <b-col cols="12" class="mb-3">
                        <div class="custom-control custom-checkbox">
                            <input class="custom-control-input" type="checkbox" id="rellenar_datos_abonos" v-model="rellenar_datos_abonos" />
                            <label for="rellenar_datos_abonos" class="custom-control-label h5 mt-1">
                                Rellenar los datos del primer abono con los datos del comprador
                            </label>
                        </div>
                    </b-col>
                    <b-col
                        v-for="(dato_abono, index) in datos_abonos"
                        :key="'observer-' + index"
                        cols="12"
                    >
                        <DatosAbonoSGAComponent
                            :key="'abono-' + index + '-' + reload"
                            :id="'abono-' + index"
                            :datosAbonosLocal.sync="datosAbonosLocal[index]"
                            :generos="generos"
                            :index="index"
                        />
                    </b-col>
                    <b-col cols="12" class="text-right mt-1">
                        <button type="button" name="button" class="button effect-button mr-2" :class="{ 'large-button': !esMovil }" :disabled="loading" @click="$emit('volver')">
                            <span>{{ $t('formularios.atras') }}</span>
                        </button>
                        <button type="submit" name="button" class="button effect-button" :class="{ 'large-button': !esMovil }" :disabled="loading">
                            <span>{{ $t('formularios.continuar') }}</span>
                        </button>
                    </b-col>
                </b-row>
            </ValidationObserver>
        </b-container>
    </ContentOrLoading>
</template>

<script>
    import Generos from "@/mixins/Generos";
    import DatosAbonoSGAComponent from "./components/DatosAbonoSGAComponent";
    import DatosCompradorComponent from "./components/DatosCompradorComponent";

    export default {
        mixins: [Generos],
        props: {
            items_carrito: {
                type: Array,
                required: true
            },
            datos_abonos: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                datosAbonosLocal: [ ...this.datos_abonos ],
                comprador: {
                    identification: {
                        type: "DNI",
                        value: ""
                    }
                },
                rellenar_datos_abonos: false,
                loading: false,
                reload: 1
            }
        },
        methods: {
            async submit() {
                this.loading = true;

                const observerRefs = this.$refs;
                let isValid = await this.$refs.observer.validate();

                const allPhonesValid = this.datosAbonosLocal.every(abono => abono.isValidNumber);
                const allPhonesFilled = this.datosAbonosLocal.every(abono => abono.phone !== null);

                this.datos_abonos.forEach(abono => {
                    abono.error_telefono = abono.phone ? 0 : 1;
                });

                if (isValid && allPhonesValid && allPhonesFilled) {
                    this.guardarDatos();
                }

                this.loading = false;
            },
            guardarDatos() {
                this.loading = true;

                this.datosAbonosLocal = this.datosAbonosLocal.map(abono => {
                    if (abono.identification.type === 'NIF') {
                        const { lastName, birthday, ...restOfAbono } = abono;
                        return restOfAbono;
                    }
                    return abono;
                });

                const params = {
                    filters: {},
                    cart_id: this.sga_abono_cart_id,
                    items: this.datosAbonosLocal,
                    comprador: this.comprador,
                    tipo: 'abonos'
                }

                this.$store.dispatch(this.config.getVuexAlias('sga.cart.guardar-datos'), params).then(res => {
                    this.solicitarDatosCobro();
                }); 
            },
            solicitarDatosCobro() {
                const params = {
                    filters: {},
                    cart_id: this.sga_abono_cart_id
                }

                this.$store.dispatch(this.config.getVuexAlias('sga.cart.solicitar-cobro'), params).then(res => {
                    this.$emit('setDatosCobro', res.data.jet_id, res.data.formulario, res.data.session_id, res.data.cart_id);
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        computed: {
            sga_abono_cart_id() {
                return parseInt(localStorage.getItem('sga_abono_cart_id'));
            },
            esMovil() {
                return window.innerWidth <= 768;
            }
        },
        watch: {
            'comprador.name'(val) {
                if (this.rellenar_datos_abonos && this.datosAbonosLocal[0]) {
                    this.$set(this.datosAbonosLocal[0], 'name', val);
                    this.reload++;
                }
            },
            'comprador.lastName'(val) {
                if (this.rellenar_datos_abonos && this.datosAbonosLocal[0]) {
                    this.$set(this.datosAbonosLocal[0], 'lastName', val);
                    this.reload++;
                }
            },
            'comprador.email'(val) {
                if (this.rellenar_datos_abonos && this.datosAbonosLocal[0]) {
                    this.$set(this.datosAbonosLocal[0], 'email', val);
                    this.reload++;
                }
            },
            'comprador.email_confirm'(val) {
                if (this.rellenar_datos_abonos && this.datosAbonosLocal[0]) {
                    this.$set(this.datosAbonosLocal[0], 'email_confirm', val);
                    this.reload++;
                }
            },
            'comprador.phone'(val) {
                if (this.rellenar_datos_abonos && this.datosAbonosLocal[0]) {
                    this.$set(this.datosAbonosLocal[0], 'phone', val);
                    this.reload++;
                }
            },
            'comprador.identification.type'(val) {
                if (this.rellenar_datos_abonos && this.datosAbonosLocal[0]) {
                    this.datosAbonosLocal[0].identification.type = val;
                    this.reload++;
                }
            },
            'comprador.identification.value'(val) {
                if (this.rellenar_datos_abonos && this.datosAbonosLocal[0]) {
                    this.datosAbonosLocal[0].identification.value = val;
                    this.reload++;
                }
            },
            rellenar_datos_abonos(val) {
                if (val && this.datosAbonosLocal[0]) {
                    const comprador = this.comprador;

                    if (comprador.name) {
                        this.$set(this.datosAbonosLocal[0], 'name', comprador.name);
                    }
                    if (comprador.lastName) {
                        this.$set(this.datosAbonosLocal[0], 'lastName', comprador.lastName);
                    }
                    if (comprador.email) {
                        this.$set(this.datosAbonosLocal[0], 'email', comprador.email);
                    }
                    if (comprador.email_confirm) {
                        this.$set(this.datosAbonosLocal[0], 'email_confirm', comprador.email_confirm);
                    }
                    if (comprador.phone) {
                        this.$set(this.datosAbonosLocal[0], 'phone', comprador.phone);
                    }
                    if (comprador.identification) {
                        if (comprador.identification.type) {
                            this.datosAbonosLocal[0].identification.type = comprador.identification.type;
                        }
                        if (comprador.identification.value) {
                            this.datosAbonosLocal[0].identification.value = comprador.identification.value;
                        }
                    }

                    this.reload++;
                }
            }
        },
        created() {
            this.getGeneros();
        },
        components: {
            DatosAbonoSGAComponent, DatosCompradorComponent
        }
    }
</script>